import { render, staticRenderFns } from "./DashboardPanel.vue?vue&type=template&id=4d8311b6&scoped=true&"
import script from "./DashboardPanel.vue?vue&type=script&lang=js&"
export * from "./DashboardPanel.vue?vue&type=script&lang=js&"
import style1 from "./DashboardPanel.vue?vue&type=style&index=1&id=4d8311b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8311b6",
  null
  
)

export default component.exports